export * from "./simpleMaterial.js";
//# sourceMappingURL=index.js.map